module.exports = __webpack_public_path__ + "static/media/arrow-right.a3e9dc1f.svg";